import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { baseAppId } from 'settings';

export default class BackImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image: 'https://travprocdn.imgix.net/842/bg2.jpg',
      width: null,
      height: null,
    };
  }

  componentDidMount() {
    this.loadBgImage();
    this.getBackgroundSizes();
  }

  getBackgroundSizes() {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }

  loadBgImage() {
    if (window.location.href.includes('/3170')) {
      this.setState({
        image: 'https://imgtravpromobile.imgix.net/842/1732214498-1732214498.jpg',
      });
    } else if (window.location.href.includes('/3171')) {
      this.setState({
        image: 'https://imgtravpromobile.imgix.net/842/1732214498-1732214498.jpg',
      });
    } else if (window.location.href.includes('/3172')) {
      this.setState({
        image: 'https://imgtravpromobile.imgix.net/842/1693493731-1693493731.jpg',
      });
    } else if (window.location.href.includes('/3173')) {
      this.setState({
        image: 'https://imgtravpromobile.imgix.net/842/1693493759-1693493759.jpg',
      });
    } else if (window.location.href.includes('/3174')) {
      this.setState({
        image: 'https://imgtravpromobile.imgix.net/842/1693493990-1693493990.jpg',
      });
    } else if (window.location.href.includes('/2866')) {
      this.setState({
        image: 'https://imgtravpromobile.imgix.net/842/1642499982-1642499982.jpg',
      });
    } else if (window.location.href.includes('/2867')) {
      this.setState({
        image: 'https://imgtravpromobile.imgix.net/842/1642961385-1642961385.jpg',
      });
    } else if (window.location.href.includes('/2868')) {
      this.setState({
        image: 'https://imgtravpromobile.imgix.net/842/1642961413-1642961413.jpg',
      });
    } else if (window.location.href.includes('/2869')) {
      this.setState({
        image: 'https://imgtravpromobile.imgix.net/842/1642961437-1642961437.jpg',
      });
    } else if (window.location.href.includes('/training')) {
      this.setState({
        image: `https://travprocdn.imgix.net/${baseAppId}/background_train.jpg`,
      });
    } else if (window.location.href.includes('/retain')) {
      this.setState({
        image: `https://travprocdn.imgix.net/${baseAppId}/background_retain.jpg`,
      });
    } else if (window.location.href.includes('/promote')) {
      this.setState({
        image: `https://travprocdn.imgix.net/${baseAppId}/background_promote.JPG`,
      });
    } else if (window.location.href.includes('/sell')) {
      this.setState({
        image: `https://travprocdn.imgix.net/${baseAppId}/background_sell.jpg`,
      });
    } else if (window.location.href.includes('/directory')) {
      this.setState({
        image: `https://travprocdn.imgix.net/${baseAppId}/background_directory.jpg`,
      });
    } else {
      this.setState({
        image: `https://travprocdn.imgix.net/${baseAppId}/bg2.jpg`,
      });
    }
  }

  render() {
    const { image, width, height } = this.state;
    const { blur, darken } = this.props;

    return (
      <div className="bgImage">
        {image && (
          <div
            style={{ backgroundImage: `url("${image}?width=${width}&height=${height}")` }}
            className={`backgroundImage ${blur && 'blur'} ${darken &&
              'darken'}`}
          />
        )}
      </div>
    );
  }
}

BackImage.propTypes = {
  blur: PropTypes.bool,
  darken: PropTypes.bool,
};

BackImage.defaultProps = {
  blur: false,
  darken: false,
};
